<app-form-layout>
  <div class="error-container">
    <h1>Something went wrong</h1>
    <h2>{{ errorMessage || 'An unexpected error occurred' }}</h2>
    <p>Please try again later or contact support if the problem persists.</p>
  </div>
</app-form-layout>
